import { WidgetConfig } from '../../components/elements/Draggable';

export const dashboardWidget: WidgetConfig[] = [
  {
    chartType: 'bar',
    display: true,
    posisi: 1,
    title: 'Training Plan vs Training Completion',
    typeDataChart: 'TCTP'
  },
  {
    chartType: 'line',
    display: true,
    posisi: 2,
    title: 'Completion Rate Program',
    typeDataChart: 'CRP'
  },
  {
    chartType: 'bar',
    display: true,
    posisi: 3,
    title: 'Training Budget Realization',
    typeDataChart: 'TBR'
  },
  {
    chartType: 'table',
    display: true,
    posisi: 4,
    title: 'Most Completed Courses',
    typeDataChart: 'MCC'
  },
  {
    chartType: 'table',
    display: true,
    posisi: 5,
    title: 'Most Favourite Course',
    typeDataChart: 'MFC'
  },
  {
    chartType: 'bar',
    display: true,
    posisi: 6,
    title: 'Completion Lecture / Employee Category',
    typeDataChart: 'CLEC'
  },
  {
    chartType: 'bar',
    display: true,
    posisi: 7,
    title: 'Learning Engagement',
    typeDataChart: 'LE'
  },
  {
    chartType: 'bar',
    display: true,
    posisi: 8,
    title: 'Satisfactory Report',
    typeDataChart: 'SR'
  },
  {
    chartType: 'bar',
    display: true,
    posisi: 9,
    title: 'Knowledge Improvement',
    typeDataChart: 'KI'
  },
  {
    chartType: 'bar',
    display: true,
    posisi: 9,
    title: 'List of Course',
    typeDataChart: 'LOC'
  }
];
